import * as fromDatatype from '../../../../../models/datatype-library';

export class BatchPaymentStatusUpdateRequestDto {
    guids: string[];
    paymentStatus: fromDatatype.VarcharDatatypeInterface;
}